import { RemoteLoadCarSpecsLists } from "../../usecases";
import { LoadCarSpecsLists } from "../../../domain/usecases";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeRemoteLoadCarSpecsLists = (): LoadCarSpecsLists =>
  new RemoteLoadCarSpecsLists(makeApiUrl("/vehicles"), makeAxiosHttpClient());
